import { tv } from '~/utils/tv'

export const modalVariants = tv({
  base: 'relative bg-transparent [z-index:999]',
  variants: {
    variant: {
      sm: 'h-auto min-w-[240px] max-w-[319px]',
      md: 'h-auto min-w-[320px] max-w-[719px]',
      lg: 'h-auto min-w-[720px] max-w-[1151px]',
      xl: 'h-auto min-w-[1152px] max-w-[1920px]',
    },
  },
  defaultVariants: {
    variant: 'sm',
  },
})
